module.exports = __webpack_public_path__ + "static/img/ewm.28e48b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/ewm.png
// module id = YmQ1
// module chunks = 8